// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import axios from 'axios'
import Vuex from 'vuex'
// 校验组件
import VeeValidate, { Validator } from 'vee-validate'
import cn from 'vee-validate/dist/locale/zh_CN'
import url from '@/modules/url'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import moment from 'moment'
import baseUrl from '@/assets/js/baseUrl.js'
import localStorage from '@/components/cache/localStorage'
import { rebaseApiPageUrl } from '@/components/utils/apiPageJump'
import { installRouteGuard } from './router/guard'
// swiper
import 'swiper/dist/css/swiper.css'
import elCascaderMulti from 'el-cascader-multi'
import infiniteScroll from 'vue-infinite-scroll'
import "@/components/utils/banreclick"

Vue.use(infiniteScroll)
Vue.use(elCascaderMulti)
Vue.use(VueDirectiveImagePreviewer)
Vue.prototype.$url = url
    // elementUI初始化
Vue.use(ElementUI)

// Vue.use(VeeValidate)
Vue.use(VeeValidate, {
    events: 'blur'
})

Vue.use(Vuex)
    // 提示语汉化
Validator.locale = 'zh_CN'
Validator.localize(Validator.locale, {
    messages: cn.messages,
    attributes: {
        myName: '登录名',
        loginPassword: '密码'
    }
})

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.moment = moment
Vue.prototype.$loginFront = baseUrl.loginFront
Vue.prototype.$loginBack = baseUrl.loginBack
Vue.prototype.$logOutFront = baseUrl.logOutFront
Vue.prototype.$logOutBack = baseUrl.logOutBack
Vue.prototype.$address = baseUrl.address
Vue.prototype.$photoUrl = baseUrl.photoUrl
Vue.prototype.$staticUrl = baseUrl.staticUrl
Vue.prototype.$getst = baseUrl.getst
Vue.prototype.$uploadImg = baseUrl.uploadImg
Vue.prototype.$deleteImg = baseUrl.deleteImg
Vue.prototype.$linkUrl = baseUrl.linkUrl
Vue.prototype.$downloadUrl = baseUrl.downloadUrl
Vue.prototype.$pageAdressUrl = baseUrl.pageAdressUrl
Vue.prototype.$testLink = baseUrl.testLink
Vue.prototype.$bigUrl = baseUrl.bigUrl
Vue.prototype.$rebaseApiPageUrl = rebaseApiPageUrl
/* eslint-disable no-new */

installRouteGuard(router)

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js